import { Component, HostBinding, Input, OnInit } from '@angular/core';

import { SafePipe } from '@app/components/pipes/safe/safe.pipe';

@Component({
    selector: 'app-text-clamp-shell',
    templateUrl: './text-clamp-shell.component.html',
    styleUrls: ['./text-clamp-shell.component.scss'],
    imports: [SafePipe]
})
export class TextClampShellComponent implements OnInit {
  _data: string;

  @Input() loadNgContent: boolean = Boolean(false);

  @HostBinding('style.color') color;
  @HostBinding('style.overflow') overflow: string;
  @HostBinding('style.text-overflow') textOverflow: string;
  @HostBinding('style.display') display: string;
  @HostBinding('style.-webkit-line-clamp') webkitLineClamp: number;
  @HostBinding('style.line-clamp') lineClamp: number;
  @HostBinding('style.-webkit-box-orient') webkitBoxOrient: string;

  constructor() {}

  @Input() set config(config: { data: string; row: number }) {
    if (config?.row > 0) {
      this.setClampConf(config?.row);
    } else {
    }
    this._data = config.data;
  }

  ngOnInit() {}

  setClampConf(row: number): void {
    this.overflow = 'hidden';
    this.textOverflow = 'ellipsis';
    this.display = '-webkit-box';
    this.webkitLineClamp = row;
    this.lineClamp = row;
    this.webkitBoxOrient = 'vertical';
  }
}
